module.exports = __webpack_public_path__ + "static/media/health.c571c037.svg";